import React, { useRef, useState } from "react";
import { CategorySharp, StarSharp } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { toggleUpSalesModal } from "../../features/products/productsSlice";
import { useLocation } from "react-router-dom";

interface Props {
  logo?: any;
}

function Header(props: Props) {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const handleOnBlur = () => {
    if (inputRef.current) {
      if (inputRef.current.value === "") {
        inputRef.current.style.fontFamily = "Leckerli One";
      }
    }
  };

  const handleOnFocus = () => {
    if (inputRef.current) {
      if (inputRef.current.value === "") {
        inputRef.current.style.fontFamily = "Lato";
      }
    }
  };

  return (
    <div
      className="justify-between items-center max-w-full p-2"
      style={{
        display: "grid",
        gridAutoFlow: "column",
        gridTemplateRows: "auto",
      }}
    >
      <div className="flex">
        <div className="max-w-max justify-evenly items-end px-2 flex">
          <StarSharp fontSize="small" className="text-yellow-500" />
          <StarSharp fontSize="small" className="text-yellow-500" />
          <StarSharp fontSize="small" className="text-yellow-500" />
          <StarSharp fontSize="small" className="text-yellow-500" />
          <StarSharp fontSize="small" className="text-slate-200" />
        </div>
      </div>
      <div
        onClick={(e) => dispatch(toggleUpSalesModal())}
        className="relative border border-black rounded-md flex flex-row justify-between items-center ml-2"
      >
        <div className="relative transition-all ease-linear duration-300 group min-h-max border border-white flex flex-row justify-between items-center bg-djeliba m-1 p-1">
          <CategorySharp className="hover:cursor-pointer bg-transparent border-0 text-black" />
          <span className="text-sm mx-1">Produits Similaires</span>
        </div>
      </div>
    </div>
  );
}

export default Header;
